import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';

export const WhatIs: React.FC = () => {
    const scrollToSection = (id: string) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="about" className="py-20 md:py-32 bg-white">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
                    <motion.div 
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="relative order-2 lg:order-1"
                    >
                        <div className="w-full flex justify-center items-center">
                            <img 
                                src="./limb-lengthning.jpeg" 
                                alt="Medical X-ray of legs" 
                                className="w-full max-w-xl h-auto object-contain rounded-2xl"
                            />
                        </div>
                    </motion.div>

                    <motion.div 
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                        className="order-1 lg:order-2"
                    >
                        <span className="text-[#11BC97] font-bold tracking-widest uppercase text-xs md:text-sm mb-4 block flex items-center gap-2">
                            <span className="w-8 h-[1px] bg-[#11BC97]"></span>
                            Overview
                        </span>
                        <h2 className="text-3xl md:text-5xl font-bold mb-6 md:mb-10 text-black leading-tight">What is limb lengthening?</h2>
                        <div className="space-y-6 text-gray-600 text-base md:text-lg leading-relaxed font-light mb-8 md:mb-10">
                            <p>
                                Stature lengthening (aka limb lengthening or cosmetic lengthening) is a procedure designed to help 
                                patients who feel unhappy with their body image. This can include patients who feel that they wish to be 
                                taller, who feel that their body is disproportionate, or who may be suffering from body dysphoria.
                            </p>
                            <p>
                                Whether you choose to lengthen your femur or your tibia (or both), the basic process is the same, and 
                                involves making a cut in the bone and gradually increasing the distance between the two halves, relying 
                                on your bodies own processes to fill the gap with new bone and thereby increasing its overall length. 
                            </p>
                            <div className="p-6 md:p-8 rounded-[2rem] bg-[#F8FDFB] border border-[#11BC97]/20 shadow-sm">
                                <p className="font-medium text-black text-sm md:text-base">
                                    The distance between the two parts of the bone is increased only gradually, at around 1mm of increased 
                                    length per day. Increases greater than this risks complication and deformity and the process is very 
                                    closely monitored throughout.
                                </p>
                            </div>
                        </div>

                        <div className="flex flex-col sm:flex-row gap-4">
                            <Button onClick={() => scrollToSection('contact')}>Book Free Consultation</Button>
                            {/* Technology section usually below, could scroll there */}
                            <Button variant="outline" onClick={() => scrollToSection('pricing')}>View Packages</Button>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};